import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const environmentsGetCommand = new Command(`get`)
  .description(`Show environment details`)
  .argument(`<id>`, `Environment ID`)
  .action(async (environmentId: string) => {
    const json = environmentsGetCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.environments.get({ environmentId })

      if (isQuiet()) {
        printQuiet(result.id)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printKeyValue([
          [`ID:`, result.id],
          [`Name:`, result.name],
          [`Project:`, result.projectId],
          [`Created:`, result.createdAt],
        ])
      }
    } catch (error) {
      handleError(error, json)
    }
  })
